// extracted by mini-css-extract-plugin
export default {"page__location-container":"SinglePolePage_page__location-container__DtXo+"};